import * as React from "react";
import { ClassNameMap } from "@material-ui/styles";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

interface TableHeaderProps {
  isFullTableWidth: boolean;
  classes: ClassNameMap;
}

const RequestedTableHead: React.FC<TableHeaderProps> = ({ isFullTableWidth, classes }) => {
  return isFullTableWidth ? (
    <TableHead>
      <TableRow className={classes.tableHead}>
        <TableCell width="10%" classes={{ sizeSmall: classes.tableCellPad }}>
          <span>Submitted</span>
        </TableCell>
        <TableCell width="11%" classes={{ sizeSmall: classes.tableCellPad }}>
          Patient
        </TableCell>
        <TableCell width="10%" classes={{ sizeSmall: classes.tableCellPad }}>
          Needs
        </TableCell>
        <TableCell width="20%" classes={{ sizeSmall: classes.tableCellPad }}>
          From
        </TableCell>
        <TableCell width="20%" classes={{ sizeSmall: classes.tableCellPad }}>
          To
        </TableCell>
        <TableCell width="5%" classes={{ sizeSmall: classes.tableCellPad }}>
          Pri
        </TableCell>
        <TableCell width="18%" classes={{ sizeSmall: classes.tableCellPad }}>
          Status
        </TableCell>
        <TableCell width="6%" classes={{ sizeSmall: classes.tableCellPad }}></TableCell>
      </TableRow>
    </TableHead>
  ) : (
    <TableHead>
      <TableRow className={classes.tableHead}>
        <TableCell width="10%" classes={{ sizeSmall: classes.tableCellPad }}>
          <span>Submitted</span>
        </TableCell>
        <TableCell width="26%" classes={{ sizeSmall: classes.tableCellPad }}>
          From
        </TableCell>
        <TableCell width="26%" classes={{ sizeSmall: classes.tableCellPad }}>
          To
        </TableCell>
        <TableCell width="5%" classes={{ sizeSmall: classes.tableCellPad }}>
          Pri
        </TableCell>
        <TableCell width="27%" classes={{ sizeSmall: classes.tableCellPad }}>
          Status
        </TableCell>
        <TableCell width="6%" classes={{ sizeSmall: classes.tableCellPad }}></TableCell>
      </TableRow>
    </TableHead>
  );
};

export default RequestedTableHead;
